// dataTransfer type for file rows dragged onto a sidebar folder
export const FILE_DRAG_TYPE = 'application/x-tradiepass-files'
